var React = require('react');

function NoteLetter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 4a1 1 0 000 2h5a1 1 0 100-2H5zM4 8a1 1 0 011-1h2a1 1 0 010 2H5a1 1 0 01-1-1zM14 4a1 1 0 100 2h1a1 1 0 100-2h-1z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 2a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2H2a2 2 0 01-2-2V2zm2 0h16v10H2V2z","fill":"currentColor","key":1})]);
}

NoteLetter.defaultProps = {"width":"20","height":"30","viewBox":"0 0 20 30","fill":"none"};

module.exports = NoteLetter;

NoteLetter.default = NoteLetter;
